module.exports = __webpack_public_path__ + "static/img/x5.dc64288d.png";